import { Search, Briefcase, FolderPlus, Files, MessagesSquare } from "lucide-react";

export const HIW_PILLARS = [
  {
    icon: Search,
    titleKey: "hiw_pillar_research_title",
    descKey: "hiw_pillar_research_desc",
  },
  {
    icon: Briefcase,
    titleKey: "hiw_pillar_cases_title",
    descKey: "hiw_pillar_cases_desc",
  },
];

export const HOW_IT_WORKS_STEPS = [
  { icon: Search, titleKey: "hiw_step1_title", descKey: "hiw_step1_desc" },
  { icon: FolderPlus, titleKey: "hiw_step2_title", descKey: "hiw_step2_desc" },
  { icon: Files, titleKey: "hiw_step3_title", descKey: "hiw_step3_desc" },
];

export const USE_CASES = [
  { icon: Search, titleKey: "hiw_case1_title", descKey: "hiw_case1_desc" },
  { icon: Briefcase, titleKey: "hiw_case2_title", descKey: "hiw_case2_desc" },
  { icon: MessagesSquare, titleKey: "hiw_case3_title", descKey: "hiw_case3_desc" },
];
